package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.css.functions.saturate
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.Anchor
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import ir.site.zero1plus.components.widgets.ThemeButton
import ir.site.zero1plus.model.NavBarMenu
import ir.site.zero1plus.theme.*
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

val NavHeaderHeight by StyleVariable<CSSLengthNumericValue>(64.px)

val NavHeaderStyle = SmoothColorStyle.extendedBy {
    val isDark = colorMode.isDark
    base {
        Modifier
            .backgroundColor(if (isDark) BackgroundDark.copyf(alpha = 0.65f) else BackgroundLight.copyf(alpha = 0.65f))
            .backdropFilter(saturate(180.percent), blur(5.px))
            .boxShadow(
                spreadRadius = 1.px,
                color = if (isDark) PrimaryDark.copyf(alpha = 0.20f) else PrimaryLight.copyf(alpha = 0.55f)
            )
            .zIndex(2)
            .top(0.percent)
            .position(Position.Sticky)
            .fillMaxWidth()
            .minHeight(NavHeaderHeight.value())
    }
    until(Breakpoint.MD) {
        Modifier.setVariable(NavHeaderHeight, 56.px)
    }
}


val LogoBrandStyle = CssStyle {
    base {
        Modifier.textDecorationLine(TextDecorationLine.None)
            .color(if (colorMode.isDark) TextPrimaryDark else TextPrimaryLight)
    }
}

val NavBarItemStyle = CssStyle {
    val isDark = colorMode.isDark
    base {
        Modifier.textDecorationLine(TextDecorationLine.None)
            .color(if (isDark) TextPrimaryDark else TextPrimaryLight)
            .transition(Transition.of("color", 300.ms))

    }
    hover {
        Modifier.color(if (isDark) PrimaryDark else PrimaryLight)
    }
}


@Composable
fun Header(
    onOverFlowMenuClicked: () -> Unit
) {
    Header(
        attrs = NavHeaderStyle.toAttrs()
    ) {
        Row(
            modifier = Modifier
                .fillMaxSize()
                .padding(leftRight = 24.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            NavBarMenuIcon(
                onOverFlowMenuClicked = onOverFlowMenuClicked
            )
            RightSection()
            LeftSection()

        }
    }
}


@Composable
fun RightSection() {
    Row(
        modifier = Modifier
            .displayIfAtLeast(Breakpoint.MD),
        horizontalArrangement = Arrangement.spacedBy(16.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        NavBarMenu.entries.forEach {
            NavBarItem(
                title = it.title,
                path = it.path
            )
        }
    }

}

@Composable
fun LeftSection() {
    Row(
        horizontalArrangement = Arrangement.spacedBy(30.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        ThemeButton()

        LogoBrand()

    }
}

@Composable
fun LogoBrand(){
    Anchor("/", attrs = LogoBrandStyle.toAttrs()) {
        Span(attrs = Modifier.fontSize(24.px).fontWeight(FontWeight.Black).fontStyle(FontStyle.Italic).toAttrs()) {
            SpanText(text = "zero")
            SpanText(text = "1plus", modifier = Modifier.color(PrimaryDark))
        }
    }
}


@Composable
fun NavBarItem(title: String, path: String) {
    Link(
        modifier = NavBarItemStyle.toModifier(),
        path = path,
    ) {
        Text(title)
    }
}

@Composable
fun NavBarMenuIcon(onOverFlowMenuClicked: () -> Unit) {
    FaBars(
        modifier = Modifier
            .displayUntil(Breakpoint.MD)
            .cursor(Cursor.Pointer)
            .onClick {
                onOverFlowMenuClicked()
            },
        size = IconSize.LG
    )
}


















